import { Button, Card, Container, Grid, IconButton, Snackbar, Tooltip, Typography } from "@material-ui/core";
import { green, orange, red } from "@material-ui/core/colors";
import { Add, AddOutlined, DeleteOutline, Edit, EditOutlined, FilterNone, RemoveRedEyeOutlined } from "@material-ui/icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import { withAuthorization } from "../Session";
import FormViewPage from "./FormViewPage";

const FormsManagement = (props) => {
  const { firebase } = props;
  const { t } = useTranslation();
  const history = useHistory();

  const [createdForms, setCreatedForms] = useState([]);
  const [formToView, setFormToView] = useState(null);

  useEffect(() => {
    firebase
      .managerData(firebase.currentUser().uid)
      .child("forms/created")
      .on("value", (snap) => {
        const forms = snap.val();
        !!forms &&
          setCreatedForms(
            Object.keys(forms)
              .reverse()
              .map((e) => ({ ...forms[e], key: e }))
          );
      });
    /*.once("value")
      .then((snap) => {
        const forms = snap.val();
        !!forms &&
          setCreatedForms(
            Object.keys(forms)
              .reverse()
              .map((e) => ({ ...forms[e], key: e }))
          );*
      });*/
    return () => {
      firebase.managerData(firebase?.currentUser()?.uid).child("forms/created").off("value");
    };
  }, []);

  if (formToView == null) {
    return (
      <Container style={{ marginBottom: 64, marginTop: 32 }}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography variant="h6" color="primary">
              Gestion de Registros
            </Typography>
          </Grid>
          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12} md={4} lg={4} lx={5}>
              <Button variant="outlined" color="primary" fullWidth style={{ height: "100%", borderRadius: 16, minHeight: 125 }} onClick={() => history.push(ROUTES.METAFORMS)}>
                <Add style={{ height: 48, width: 48 }} />
              </Button>
            </Grid>

            {createdForms.map((f, i) => (
              <FormationCard f={f} i={i} s={setFormToView} />
            ))}
          </Grid>
        </Grid>
      </Container>
    );
  } else {
    return <FormViewPage formData={createdForms[formToView]} backF={setFormToView} />;
  }
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(FormsManagement);

const FormationCard = ({ f, i, s }) => {
  const [workshopTimeState, setWorkshopTimeState] = useState("");
  const [color, setColor] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const QRCode = require("qrcode.react");
  const history = useHistory();
  const { i18n } = useTranslation();

  useEffect(() => {
    const now = new Date();
    const start = moment(f.formConfig.startDay, "DD/MM/yyyy");
    const end = moment(f.formConfig.endDay, "DD/MM/yyyy");

    if (moment(now).isBetween(start, end)) {
      setWorkshopTimeState("Registro abierto");
      setColor(green[600]);
    } else if (moment(now).isBefore(start)) {
      setWorkshopTimeState("Registro sin comenzar");
      setColor(orange[600]);
    } else {
      setWorkshopTimeState("Registro cerrado");
      setColor(red[600]);
    }
  }, []);

  return (
    <Grid item xs={12} md={4} xl={4}>
      <Card variant="outlined" style={{ padding: 16, borderRadius: 16 }}>
        <Grid container spacing={1}>
          <Grid item xs={8}>
            <Typography variant="h6" color="primary">
              {typeof f?.formConfig?.name == "object" ? f.formConfig.name[i18n.language.split("-")[0]] : f?.formConfig?.name}
            </Typography>
          </Grid>
          <Grid item xs={4} container justify="flex-end" alignItems="flex-start" style={{ paddingRight: 6 }}>
            <IconButton size="small" onClick={() => s(i)}>
              <RemoveRedEyeOutlined />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => {
                history.push(`${ROUTES.EDIT_METAFORM_EXACT}/${f.key}`);
              }}
            >
              <EditOutlined />
            </IconButton>
            <IconButton size="small" disabled>
              <DeleteOutline />
            </IconButton>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={8} container alignItems="flex-end" spacing={0}>
              <Grid item xs={12} container alignItems="flex-end" justify="space-between">
                <Typography style={{ color: color }}>{workshopTimeState}</Typography>
                <Typography variant="body1" style={{}}>
                  {f?.formConfig?.url?.substr(0, 22)}...
                </Typography>
                <Tooltip title="Copiar url" aria-label="add">
                  <IconButton
                    style={{ marginLeft: 6, padding: 0 }}
                    onClick={() => {
                      setSnackOpen(true);
                      navigator?.clipboard?.writeText(f?.formConfig?.url);
                    }}
                  >
                    <FilterNone />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid item xs={4} container justify="flex-end">
              {!!f?.formConfig?.url && <QRCode value={f?.formConfig?.url} size={92} />}
            </Grid>
          </Grid>
        </Grid>
      </Card>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={snackOpen}
        autoHideDuration={3000}
        onClose={() => setSnackOpen(false)}
        message={navigator?.clipboard === undefined ? "No se ha podido copiar al portapapeles" : "Copiado al portapapeles"}
      />
    </Grid>
  );
};
